import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { FcpButtonModule } from 'fc-ui-components';
import { TranslateModule } from '@ngx-translate/core';

import { MobileMenuComponent } from './mobile-menu.component';
import { DirectivesModule } from 'app/directives/directives.module';

@NgModule({
    declarations: [MobileMenuComponent],
    exports: [MobileMenuComponent],
    imports: [CommonModule, MatSidenavModule, TranslateModule, FcpButtonModule, RouterModule, DirectivesModule]
})
export class MobileMenuModule {}
